"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trainingKeyToFriendlyName = exports.diaperKeyToFriendlyName = void 0;
/** map DiaperSize to user-friendly values */
exports.diaperKeyToFriendlyName = {
    diaper_n: 'N',
    diaper_1: '1',
    diaper_2: '2',
    diaper_3: '3',
    diaper_4: '4',
    diaper_5: '5',
    diaper_6: '6',
};
/** map TrainingSize to user-friendly values */
exports.trainingKeyToFriendlyName = {
    training_12_24: '12-24M',
    training_2t_3t: '2T-3T',
    training_3t_4t: '3T-4T',
    training_4t_5t: '4T-5T',
};
